import { ReactNode } from "react";
import { cn } from "../../lib/utils";

export function EmptyState({
  icon,
  title,
  description,
  className,
}: {
  icon: ReactNode;
  title: string;
  description?: string;
  className?: string;
}): React.JSX.Element {
  return (
    <div
      className={cn(
        "flex flex-col items-center justify-center gap-3",
        className
      )}
    >
      <div className="flex size-14 items-center justify-center rounded-full bg-[#d5f6ef]">
        {icon}
      </div>
      <div className="flex flex-col items-center gap-1.5 text-center">
        <p className="text-sm font-bold text-primary-black">{title}</p>
        {description !== undefined && (
          <p className="text-xs text-secondary-bluegrey-4">{description}</p>
        )}
      </div>
    </div>
  );
}
